<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.date"
            :error="form.errors.date"
            type="date"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Date')"
          />

          <select-edit-input
            placeholder="Search Customer"
            :onInput="filterOrganization"
            :items="organization"
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('User')"
            :value="data_exit_goods.organization"
            :editable="user_access.outgoing_asset.update"
          ></select-edit-input>

          <select-edit-input
            placeholder="Search User"
            :onInput="filterCustomer"
            :items="customer"
            v-model="form.customer_id"
            :error="form.errors.customer_id"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Customer')"
            :value="data_exit_goods.customer"
            :editable="user_access.outgoing_asset.update"
          ></select-edit-input>

          <select-input
            v-model="form.type_outgoing"
            :required="true"
            :error="form.errors.type_outgoing"
            class="pr-6 pb-8 w-full lg:w-1/3"
            :label="__('Type Outgoing')"
          >
            <option :value="null">{{ __('Select Type') }}</option>
            <option v-for="s in type_outgoings" :key="s.value" :value="s.value">{{ s.name }}</option>
          </select-input>

          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            :rows="8"
            class="pb-6 w-full lg:w-1/1"
            placeholder="description here.."
            :label="__('Note')"
          ></textarea-input>

          <!-- Detail Section -->
          <div class="pr-6 pb-8 w-full">
            <label class="form-label mb-6">{{ __('Details') }}:</label>

            <!-- Table for Details -->
            <div class="pr-6 pb-8 w-full mt-12">
              <label class="form-label mb-6">{{ __('Details') }}:</label>
              <div class="bg-white rounded-md shadow overflow-x-auto">
                <table class="min-w-full border border-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="px-4 py-2 text-left">{{ __('No') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Category') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Brand') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Type') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Serial Number') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('User') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Qty') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Status') }}</th>
                      <th class="px-4 py-2 text-left">{{ __('Action') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(detail, index) in form.details" :key="index">
                      <td class="px-4 py-2">{{ index + 1 }}</td>
                      <td class="px-4 py-2">{{ detail.category }}</td>
                      <td class="px-4 py-2">{{ detail.brand }}</td>
                      <td class="px-4 py-2">{{ detail.type }}</td>
                      <td class="px-4 py-2">{{ detail.serial_number }}</td>
                      <td class="px-4 py-2">
                        <!-- Kondisi user_id -->
                        <select-input-filter
                          v-if="!detail.user_id"
                          placeholder="Select User"
                          :onInput="filterCustomerTicket"
                          :items="customer_ticket"
                          v-model="detail.user_id_new"
                          :error="form.errors[`details.${index}.user_id`]"
                          class="w-full"
                        />
                        <select-edit-input
                          v-else
                          placeholder="Search User"
                          :onInput="filterCustomerTicket"
                          :items="customer_ticket"
                          v-model="detail.user_id"
                          :error="form.errors[`details.${index}.user_id`]"
                          class="w-full"
                          :value="detail.user"
                          :trash="true"
                          :editable="user_access?.outgoing_asset?.update"
                        />
                      </td>
                      <td class="px-4 py-2">
                        <text-input
                          v-model="detail.qty"
                          :error="form.errors[`details.${index}.qty`]"
                          type="number"
                          min="1"
                          class="w-full"
                          @input="validateQty(detail, index)"
                        />
                      </td>
                      <td class="px-4 py-2">
                        <span
                          v-if="detail.resign"
                          class="px-2 py-0.5 rounded-full text-white bg-green-500 font-bold text-xs"
                        >In Stock</span>
                        <span
                          v-else
                          class="px-2 py-0.5 rounded-full text-white bg-red-500 font-bold text-xs"
                        >Out of Stock</span>
                      </td>
                      <td class="px-4 py-2">
                        <button
                          v-if="detail.resign == false && detail.status !== 'sold'"
                          type="button"
                          class="text-red-500"
                          @click="removeDetail(index)"
                        >
                          <icon name="trash" class="block w-5 h-5 text-red-600" />
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <button
              class="text-blue-500 mt-4"
              type="button"
              @click="openModal"
            >{{ __('Add another asset') }}</button>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit"
          >{{ __('Update') }}</loading-button>
        </div>
      </form>

      <!-- Modal for Adding Asset -->
      <ModalAsset :showModal="showModal" @close="closeModal" @assetsSelected="addAssetDetails" />
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import { formatDate } from '@/utils/dateFormatter.js'
import ModalAsset from '@/Pages/ExitGoods/ModalAsset'
import SelectEditInput from '@/Shared/SelectEditInput'
import Icon from '@/Shared/Icon'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'

export default {
  metaInfo() {
    return { title: this.title }
  },
  components: {
    LoadingButton,
    TextInput,
    SelectInput,
    Head,
    SelectEditInput,
    ModalAsset,
    Icon,
    TextareaInput,
    SelectInputFilter,
  },
  layout: Layout,
  props: {
    title: String,
    data_exit_goods: Object,
    asset: Array,
    customer: Array,
    organization: Array,
    brand: Array,
    category: Array,
    type_outgoings: Array,
    customer_ticket: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        date: formatDate(this.data_exit_goods.date, 'YYYY-MM-DD'),
        customer: this.data_exit_goods.customer,
        customer_id: this.data_exit_goods.customer_id,
        organization_id: this.data_exit_goods.organization_id,
        organization: this.data_exit_goods.organization,
        description: this.data_exit_goods.description,
        type_outgoing: this.data_exit_goods.type_outgoing,
        details: this.data_exit_goods.details.map((detail) => ({
          asset_id: detail.asset_id,
          category: detail.category,
          brand: detail.brand,
          type: detail.type,
          serial_number: detail.serial_number,
          qty: detail.qty,
          user: detail.user,
          status: detail.status,
          resign: detail.resign,
          user_id: detail.user_id ?? null,
          user_id_new: detail.user_id_new ?? null,
        })),
      }),
      showModal: false,
      editItem: true,
      user_access: this.$page.props.auth.user.access,
    }
  },
  methods: {
    update() {
      this.form.put(this.route('exit_goods.update', this.data_exit_goods.id))
    },
    validateQty(detail, index) {
      if (detail.qty < 1) {
        this.$set(this.form.errors, `details.${index}.qty`, 'Quantity must be at least 1')
      } else {
        this.$delete(this.form.errors, `details.${index}.qty`)
      }
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    addAssetDetails(selectedAssets) {
      selectedAssets.forEach((asset) => {
        this.form.details.push({
          asset_id: asset.id,
          category: asset.category,
          brand: asset.brand,
          type: asset.type,
          serial_number: asset.serial_number, // Make sure this matches your form
          user_id: null,
          qty: 1,
          resign: false,
        })
      })
      this.closeModal()
    },
    removeDetail(index) {
      this.form.details.splice(index, 1)
    },
    filterOrganization(e) {
      axios.get(this.route('filter.organizations', { search: e.target.value })).then((res) => {
        this.organization.splice(0, this.organization.length, ...res.data)
      })
    },
    filterCustomer(e) {
      axios.get(this.route('filter.outgoing_user', { search: e.target.value })).then((res) => {
        this.customer.splice(0, this.customer.length, ...res.data)
      })
    },
    toggleEditCustomer() {
      this.editItem
    },
    filterCustomerTicket(e) {
      axios.get(this.route('filter.customer_ticket', { search: e.target.value })).then((res) => {
        this.customer_ticket.splice(0, this.customer_ticket.length, ...res.data)
      })
    },
  },
}
</script>
